import * as actions from "./actions";

/**
 * These are the redux "operations" that are available from container HOCs
 * In this redux implementation, container HOCs do not dispatch actions directly,
 * but I've seen other redux implementations where they do.
 */

const fetchAllLocations = () => dispatch =>
    dispatch(actions.loadAllLocations());

const fetchLocations = location => dispatch =>
    dispatch(actions.loadLocations(location));

export { fetchAllLocations, fetchLocations };



// WEBPACK FOOTER //
// ./ducks/location-index/operations.js